import React, { useEffect, useState } from "react";
import "../../../style/partner.css";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { apiAxios } from "../../../utils/apiAxios";

const DeliveryPartner = () => {

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [stats, setStats] = useState({ totalOrders: 0, delivered: 0, clinics: 0, partners: 0 });
  const perPage = 10;

  // 🔥 FETCH API
  const fetchData = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const res = await apiAxios.get("/Manager/delivery-partner-orders", {
        params: {
          Search: "",
          PageNumber: pageNumber,
          PageSize: perPage
        }
      });

      const json = res.data;

      if (json.isSuccess) {

        const mapped = json.dataOne.data.map((item: any, index: number) => ({
          index: (page - 1) * perPage + index, // ✅ now valid
          orderId: item.orderID ?? "-",
          clinic: item.clinic ?? "-",
          clinicPhone: item.clinicPhone ?? "-",
          dentist: item.dentist ?? "-",
          dentistPhone: item.dentistPhone ?? "-",
          milling: item.milling ?? "-",
          millingPhone: item.millingPhone ?? "-",
          delivery: item.delivery ?? "-",
          deliveryPhone: item.deliveryPhone ?? "-",
            date: item.deliveredOn
  ? new Date(item.deliveredOn).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    })
  : "-",
          time: item.deliveryTime ?? "-",
          status: item.status ?? "Pending"
        }));

        setData(mapped);
        setTotalRows(json.dataOne.totalRecords);

      } else {
        toast.error("No data found");
      }

    } catch (err) {
      console.error(err);
      toast.error("API failed");
    } finally {
      setLoading(false);
    }
  };



  const fetchStats = async () => {
    try {
      const res = await apiAxios.get("/Manager/delivery-partner-stats");

      if (res.data.isSuccess) {
        const s = res.data.singleData;

        setStats({
          totalOrders: s.totalOrders,
          delivered: s.deliveredCount,
          clinics: s.totalClinics,
          partners: s.totalPartners
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Stats API failed");
    }
  };


  useEffect(() => {
    fetchData(page);
    fetchStats();
  }, [page]);

  // 🔥 COLUMNS
  const columns = [
    {
      name: "Order ID",
      selector: (row: any) => row.orderId,
      center: true,
      width: "90px"
    },
    {
      name: "Clinic",
      cell: (row: any) => (
        <div className="name-cell">
          <div className="name">{row.clinic}</div>
          <div className="phone">{row.clinicPhone}</div>
        </div>
      ),
      minWidth: "150px"
    },
    {
      name: "Dentist",
      cell: (row: any) => (
        <div className="name-cell">
          <div className="name">{row.dentist}</div>
          <div className="phone">{row.dentistPhone}</div>
        </div>
      ),
      minWidth: "150px"
    },
    {
      name: "Milling",
      cell: (row: any) => (
        <div className="name-cell">
          <div className="name">{row.milling}</div>
          <div className="phone">{row.millingPhone}</div>
        </div>
      ),
      minWidth: "150px"
    },
    {
      name: "Delivery",
      cell: (row: any) => (
        <div className="name-cell highlight">
          <div className="name">{row.delivery}</div>
          <div className="phone">{row.deliveryPhone}</div>
        </div>
      ),
      minWidth: "150px"
    },
    {
      name: "DeliveredOn",
      selector: (row: any) => row.date,
      center: true
    },
    {
      name: "Time",
      cell: (row: any) => (
        <span className="time">{row.time}</span>
      ),
      center: true,
      width: "180px"
    },
    {
      name: "Status",
      cell: (row: any) => (
        <span className={`badge ${row.status === "Delivered"
            ? "bg-success"
            : row.status === "Pending"
              ? "bg-warning"
              : "bg-danger"
          }`}>
          {row.status}
        </span>
      ),
      center: true,

    }
  ];

  const totalOrders = stats.totalOrders;
  const delivered = stats.delivered;
  const clinics = stats.clinics;
  const partners = stats.partners;
  return (
    <div className="mt-2">

      <h4 className="mb-4">Delivery Partner Details</h4>


      <div className="order-status-bar mb-4">

        {/* 🔹 Total Orders */}
        <div className="status-col total-orders">
          <h3>{totalOrders}</h3>
          <div className="status-badge total">
            <i className="bi bi-list-check"></i>
            Total Orders
          </div>
        </div>

        {/* 🔹 Clinics */}
        <div className="status-col clinics">
          <h3>{clinics}</h3>
          <div className="status-badge clinics-badge">
            <i className="bi bi-hospital"></i>
            Clinics
          </div>
        </div>

        {/* 🔹 Delivery Partners */}
        <div className="status-col delivery-partners">
          <h3>{partners}</h3>
          <div className="status-badge partners-badge">
            <i className="bi bi-truck"></i>
            Delivery Partners
          </div>
        </div>

        {/* 🔹 Delivered */}
        <div className="status-col delivered">
          <h3>{delivered}</h3>
          <div className="status-badge delivered-badge">
            <i className="bi bi-check-circle"></i>
            Delivered
          </div>
        </div>

      </div>
      {/* TABLE */}
      <div className="premium-card mt-4">

        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={(p) => setPage(p)}
          progressPending={loading}
          striped
          highlightOnHover
          responsive

        />

      </div>

    </div>
  );
};

export default DeliveryPartner;